var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import { showAlert as showAlertAction, showNotification as showNotificationAction, } from '@/actions/NotificationActions';
import { apiUpdateProfile } from '@/actions/ProfileActions';
import { withAuthentication } from '@/components/functional/Hoc/WithAuthentication/WithAuthentication';
import { POSITION_CANDIDATES } from '@/define/consts/profile';
import { isClientPreStatus } from '@/helpers/auth';
import { propFunc, propShape, PropTypesAuthToken, } from '@/helpers/custom-prop-types';
import { hasRequiredParam } from '@/helpers/user/UserProfileHelper';
import compose from '@/utils/compose/compose';
import Layout from '../../Layout';
import FormProfileEdit from './FormProfileEdit';
class ProfileEdit extends Component {
    constructor(props) {
        super(props);
        this.getState = (props) => {
            const { profile } = props;
            const positionIdList = POSITION_CANDIDATES.map((v) => v.value);
            let initialPosition = profile.information.position;
            const initialPositionNumber = initialPosition
                ? parseInt(initialPosition, 10)
                : 0;
            if (!positionIdList.includes(initialPositionNumber)) {
                initialPosition = '';
            }
            return {
                initialValues: {
                    address1: profile.information.address1,
                    address2: profile.information.address2,
                    address3: profile.information.address3,
                    company: (profile.organization || {}).name,
                    department: profile.information.department,
                    email: profile.email,
                    firstName: profile.information.firstName,
                    firstNameKana: profile.information.firstNameKana,
                    lastName: profile.information.lastName,
                    lastNameKana: profile.information.lastNameKana,
                    occupation: profile.information.occupation,
                    occupationOther: profile.information.occupationOther,
                    password: '',
                    phone1: profile.information.phone1,
                    phone2: profile.information.phone2,
                    phone3: profile.information.phone3,
                    position: initialPosition.toString(),
                    positionOther: profile.information.positionOther,
                    prefecture: profile.information.prefecture,
                    zipCode1: profile.information.zipCode1,
                    zipCode2: profile.information.zipCode2,
                },
                preStatus: isClientPreStatus(profile),
            };
        };
        this.onSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
            const { showAlert, showNotification, updateProfile } = this.props;
            try {
                yield updateProfile(values);
                showNotification('プロフィールを更新しました。');
            }
            catch (e) {
                showAlert('システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。');
                throw e;
            }
        });
        this.state = this.getState(props);
    }
    componentDidMount() {
        const { auth, profile, showAlert } = this.props;
        if (!hasRequiredParam(auth, profile)) {
            showAlert('プロフィール情報が不十分です。必須項目を入力してください。');
        }
    }
    shouldComponentUpdate(nextProps) {
        const { profile } = this.props;
        if (profile !== nextProps.profile) {
            this.setState(this.getState(nextProps));
            return false;
        }
        return true;
    }
    render() {
        const { profile } = this.props;
        const { organizationCandidate } = profile;
        const { initialValues, preStatus } = this.state;
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsx("header", Object.assign({ className: 'l-sub-header l-sub-header-profile l-container-12' }, { children: _jsx("h1", { children: "Profile" }) })), _jsx("div", Object.assign({ className: 'l-container l-contents-form l-container-9 md-l-container-full' }, { children: _jsx(FormProfileEdit, { companyCandidate: organizationCandidate, enableReinitialize: true, initialValues: initialValues, onSubmit: this.onSubmit, preStatus: preStatus }) }))] })));
    }
}
ProfileEdit.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    profile: propShape(),
    showAlert: propFunc().isRequired,
    showNotification: propFunc().isRequired,
    updateProfile: propFunc().isRequired,
};
ProfileEdit.defaultProps = {
    profile: {},
};
const mapStateToProps = ({ auth, profile }) => ({ auth, profile });
const mapDispatchToProps = (dispatch) => ({
    showAlert: (message) => dispatch(showAlertAction(message)),
    showNotification: (message) => dispatch(showNotificationAction(message)),
    updateProfile: (values) => new Promise((resolve, reject) => {
        dispatch(apiUpdateProfile(values, {
            form: 'FormProfileEdit',
            reject,
            resolve,
        }));
    }),
});
const enhance = compose(withAuthentication({ isClient: true }), connect(mapStateToProps, mapDispatchToProps));
export default enhance(ProfileEdit);
